import { AbstractControl, UntypedFormArray, ValidationErrors } from '@angular/forms';

export function arrayMax(max = 1) {
  return (control: AbstractControl): ValidationErrors => {
    if (!control || !control.value?.length) return null;
    const invalid = (control as UntypedFormArray)?.value?.length > max;
    return invalid ? { arrayMax: true } : null;
  };
}
